
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34835',
  depVersions: {
  "documents-public-ui": "static-1.34835",
  "atom": "static-1.5210",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2632",
  "client-types": "static-1.486",
  "cssUtils": "static-1.832",
  "customer-data-filters-ui": "static-1.40264",
  "customer-data-objects": "static-1.7813",
  "customer-data-property-utils": "static-1.8229",
  "documents-lib": "static-1.34840",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.349",
  "FormsCommonComponents": "static-1.86174",
  "FormUrlGenerator": "static-2.4856",
  "foundations-theming-specialty": "static-1.2284",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5728",
  "hs-test-utils": "static-1.8154",
  "hub-http": "static-1.6356",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11912",
  "HubStyleTokens": "static-2.11605",
  "I18n": "static-7.1642",
  "icons": "static-2.656",
  "jasmine-immutable": "static-1.3156",
  "jasmine-runner": "static-1.6591",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7286",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5530",
  "quartz": "static-1.7210",
  "react": "static-7.187",
  "react-dlb": "static-1.81",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16819",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5442",
  "react-virtualized": "static-2.100",
  "reference-resolvers": "static-1.8310",
  "reference-resolvers-lite": "static-1.8230",
  "reporting-data": "static-1.68098",
  "reporting-reports": "static-1.67776",
  "reporting-snowflake": "static-1.56716",
  "reporting-testing-lib": "static-1.10031",
  "reporting-visualizations": "static-1.60174",
  "reselect": "static-3.6",
  "sales-content-partitioning": "static-1.9082",
  "sanitize": "static-1.4611",
  "sanitize-text": "static-1.8281",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1879",
  "signup-constants": "static-1.19188",
  "signup-ui-url-generator": "static-2.8192",
  "StyleGuideUI": "static-3.489",
  "superstore": "static-1.4893",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4894",
  "ui-addon-form-validation": "static-1.11125",
  "ui-asset-management-lib": "static-1.11210",
  "ui-images": "static-2.1190",
  "UIComponents": "static-3.8551",
  "usage-tracker": "static-1.7485",
  "usage-tracker-container": "static-1.7475",
  "usage-tracker-core": "static-1.7335",
  "viral-links-lib": "static-1.7204",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9794",
  "foundations-components": "static-1.8197",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.988",
  "quartz-core": "static-1.6429",
  "quick-fetch": "static-1.4018",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4791",
  "ui-addon-i18n": "static-1.11283",
  "ui-addon-upgrades": "static-9.18176",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3500",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3487",
  "quartz-webpack": "static-1.3434",
  "foundations-assets": "static-1.5008",
  "foundations-theming": "static-1.4568",
  "hub-http-shared-msw-handlers": "static-1.10293",
  "hubspotter-http": "static-1.4752",
  "sassPrefix": "static-1.158",
  "conversations-skeleton-state": "static-1.7380",
  "crm-message-bus": "static-1.43338",
  "customer-data-filters-ui-msw-helpers": "static-1.22699",
  "customer-data-objects-ui-components": "static-1.13163",
  "customer-data-reference-ui-components": "static-1.13309",
  "customer-data-ui-utilities": "static-1.9958",
  "events-data-lib": "static-1.369",
  "framework-builder-read-service-client": "static-1.4106",
  "framework-data-schema-quick-fetch": "static-1.6933",
  "framework-data-schema-resolvers": "static-1.7028",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3688",
  "inbound-db-properties-service-client": "static-1.3947",
  "multi-account-reference-resolvers": "static-1.1116",
  "onboarding-tours": "static-1.16857",
  "reporting-datasets-permissions-lib": "static-1.14060",
  "stylex": "static-1.35",
  "trellis-assets": "static-1.2220",
  "trellis-components": "static-1.2239",
  "trellis-theming": "static-1.1077",
  "ui-addon-teams": "static-1.21724",
  "quartz-auth": "static-1.885",
  "ui-business-units-lib": "static-1.9203",
  "usage-tracker-session-replay": "static-1.5171",
  "ai-components-ui-library": "static-1.9286",
  "ContentUtils": "static-1.68753",
  "customer-data-properties": "static-1-sbelsky-fix-property-definition-memoization.3",
  "forms-ai-lib": "static-1.4529",
  "forms-utils-lib": "static-1.12835",
  "foundations-components-test-utils": "static-1.5680",
  "react-dnd-compat": "static-1.4748",
  "react-tinymce": "static-1.55595",
  "tinymce-config": "static-2.54721",
  "ui-gdpr-components": "static-1.10485",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3553",
  "HeadJS": "static-2.774",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3265",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.182",
  "ui-fonts": "static-1.867",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4459",
  "csstype": "static-1.50",
  "quartz-head": "static-1.875",
  "web-vitals": "static-1.7",
  "batch-promise": "static-1.1678",
  "external-options-client-types": "static-1.4228",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.885",
  "frontend-preferences-client": "static-1.8060",
  "graphql": "static-1.83",
  "persist-promise": "static-1.3835",
  "reporting-client-types": "static-1.2581",
  "apollo-stack-hubspot": "static-3.87",
  "growth-payments-core": "static-1.25767",
  "hubspot-apollo-client": "static-1.5011",
  "foundations-components-legacy": "static-1.1222",
  "quartz-routing": "static-1.640",
  "hs-story-utils": "static-1.9556",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.373",
  "timezone-utils": "static-2.5377",
  "seat-types-lib": "static-1.311",
  "react-create-root-preference": "static-1.40",
  "bend-plugin-foundations-components": "static-1.4466",
  "floating-ui": "static-1.58",
  "react-aria": "static-1.67",
  "tanstack-table": "static-1.56",
  "dispatcher": "static-1.139",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.849",
  "mobile-manifest-mixins": "static-1.548",
  "module-federation": "static-1.27",
  "quartz-test": "static-1.885",
  "quartz-tracking": "static-1.589",
  "bend-plugin-chirp-manifest": "static-1.201",
  "chirp-fetch": "static-1.2022",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6118",
  "salesImages": "static-1.527",
  "ts-schema": "static-1.4182",
  "bender-build-tools": "static-1.3301",
  "calling-global-api": "static-1.64952",
  "calling-internal-common": "static-1.31446",
  "calling-lifecycle-internal": "static-1.66334",
  "calling-lifecycle-messages": "static-1.58628",
  "commerce-products-lib": "static-1.10059",
  "conditional-properties-service-client": "static-1.3899",
  "crm-links": "static-1.6442",
  "crm-pipelines-api-client-types": "static-1.4238",
  "customer-data-properties-shared-msw-handlers": "static-1.9620",
  "file-manager-components": "static-1.24000",
  "google-libphonenumber": "static-1.39",
  "hs-resources": "static-1.312",
  "inbounddb-objects-service-types": "static-1.4318",
  "meetings-icalendar-utils-lib": "static-1.767",
  "multi-currency-client-types": "static-1.3792",
  "object-builder-ui-client": "static-1.49207",
  "pipeline-validation-client-types": "static-1.4066",
  "property-value-citations": "static-1-sbelsky-fix-property-definition-memoization.3",
  "pulse": "static-1.738",
  "smart-property-lib": "static-1.7944",
  "tiered-pricing": "static-1.1565",
  "ui-addon-iframeable": "static-1.9202",
  "user-context": "static-1.5242",
  "zustand": "static-1.74",
  "bend-plugin-foundations-theming": "static-1.3051",
  "restore-request-side-panel-lib": "static-1.1226",
  "react-immutable-render-mixin": "static-1.9",
  "fdsr-migration-layer": "static-1.147",
  "getting-started-shared-tasks": "static-1.18783",
  "growth-data-modal": "static-1.5649",
  "growth-onboarding-confetti": "static-1.3199",
  "growth-onboarding-next-action-utils": "static-1.2299",
  "navigation-components": "static-1.18325",
  "onboarding-tours-client": "static-1.5071",
  "onboarding-tours-utils": "static-1.923",
  "ui-shepherd-react": "static-3.10387",
  "ui-shepherd-tracker": "static-1.7768",
  "ui-universal-auth": "static-1.9140",
  "base-ui": "static-1.15",
  "react-day-picker": "static-1.4",
  "tanstack-virtual": "static-1.31",
  "hubspotter-http-shared-msw-handlers": "static-1.10291",
  "magpie-lib": "static-1.5642",
  "navigation-messaging": "static-1.7652",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21936",
  "copilot-toolkit": "static-1.11475",
  "cms-field-types": "static-1.4949",
  "content-icons-ui": "static-1.2267",
  "integrations-lib": "static-1.16572",
  "final-form": "static-1.71",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.20061",
  "tinymce-themes": "static-1.56691",
  "data-token-picker": "static-1.16643",
  "hub-http-contrib": "static-1.3177",
  "interframe": "static-3.4892",
  "tinymce-data": "static-1.40806",
  "tinymce-plugins": "static-1.57835",
  "ui-addon-sales-email": "static-1.5344",
  "onboarding-scopes": "static-1.6594",
  "ui-addon-opt": "static-4.8496",
  "apollo-link-hub-http": "static-2.4784",
  "hubspot-apollo-cache": "static-1.470",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.308",
  "purchase-motions-api": "static-1.6121",
  "calling-error-reporting": "static-1.31453",
  "shared-worker-versioning": "static-1.11169",
  "calling-usage-tracker": "static-1.6677",
  "voice-sms-access-library": "static-1.1487",
  "customer-data-tracking": "static-1.7020",
  "commerce-permissions": "static-1.909",
  "products-iframe-lib": "static-1.8298",
  "products-ui-components-shared-msw-handlers": "static-1.10675",
  "location-customization-utils-lib": "static-1.9638",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1177",
  "immerable": "static-1.4284",
  "video-components-external": "static-1.11722",
  "video-data-lib": "static-1.35380",
  "event-emitter": "static-1.1084",
  "bend-plugin-pulse": "static-1.241",
  "fast-json-patch": "static-1.64",
  "data-agent-kit": "static-1.417",
  "feedback-loader": "static-1.29544",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10376",
  "fsm": "static-1.3865",
  "policy-lib": "static-1.6920",
  "react-colorpicker": "static-2.10341",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10439",
  "getting-started-shared-tasks-store": "static-1.17901",
  "onboarding-data-sync-lib": "static-1.2200",
  "growth-onboarding-next-action-components": "static-1.2327",
  "user-context-client": "static-1.4713",
  "idb-keyval": "static-1.45",
  "magpie-types": "static-1.5102",
  "nest": "static-1.366",
  "reactive-lib": "static-1.860",
  "simple-logging-lib": "static-1.3183",
  "unified-auth-core-lib": "static-1.936",
  "markdown-it": "static-1.6",
  "integrations-error-boundary-lib": "static-1.13987",
  "integrations-tracking-lib": "static-1.5741",
  "native-integrations-shared-strings": "static-1.7915",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10496",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.654",
  "FileManagerLib": "static-1.39640",
  "NamespacedHubStyle": "static-2.9155",
  "FileManagerCore": "static-1.39499",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7966",
  "layout-dnd-components": "static-1.12707",
  "layout-dnd-utils": "static-1.11682",
  "react-codemirror": "static-1.10761",
  "ui-addon-emoji-picker": "static-1.10019",
  "ui-brand-identity-lib": "static-1.15760",
  "calling-orchestration-schema": "static-1.36264",
  "sales-views-client-types": "static-1.4390",
  "crm-record-cards-service-types": "static-1.3686",
  "breeze-engine-core": "static-1.455",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "content-media-composition-data-lib": "static-1.12731",
  "content-media-compositions": "static-2.16738",
  "media-bridge-lib": "static-1.19159",
  "trellis-story-utils": "static-1.4643",
  "storybook-react": "static-1.34",
  "InboxConnectUtils": "static-4.15170",
  "meetings-connect-utils-lib": "static-1.7739",
  "universal-page-editor-lib": "static-1.3145",
  "adobe-sign-auth-lib": "static-1.64",
  "ads-unified-auth-lib": "static-1.487",
  "google-sheets-integration-lib": "static-1.626",
  "microsoft-drive-integration-lib": "static-1.784",
  "surveymonkey-integration-lib": "static-1.82",
  "slack-ui-library": "static-1.10530",
  "audio-components": "static-1.6122",
  "FileManagerImages": "static-1.37151",
  "video-components": "static-1.13724",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4668",
  "video-embed": "static-1.36214",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8839",
  "ui-coaching-tips": "static-1.28929",
  "ContentData": "static-1.68828",
  "layout-data-lib": "static-1.10007",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22397",
  "outpost": "static-1.4302",
  "growth-onboarding-feedback-components": "static-1.6713",
  "advanced-menus-core": "static-1.15350",
  "advanced-menus-lib": "static-1.12258",
  "ExportDialog": "static-6.10513",
  "ui-memberships-settings-lib": "static-1.34403",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15349",
  "simple-menus-lib": "static-1.16866"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34835",
  "atom": "/atom/static-1.5210",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2632",
  "client-types": "/client-types/static-1.486",
  "cssUtils": "/cssUtils/static-1.832",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40264",
  "customer-data-objects": "/customer-data-objects/static-1.7813",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8229",
  "documents-lib": "/documents-lib/static-1.34840",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.349",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86174",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4856",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2284",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5728",
  "hs-test-utils": "/hs-test-utils/static-1.8154",
  "hub-http": "/hub-http/static-1.6356",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11912",
  "HubStyleTokens": "/HubStyleTokens/static-2.11605",
  "I18n": "/I18n/static-7.1642",
  "icons": "/icons/static-2.656",
  "jasmine-immutable": "/jasmine-immutable/static-1.3156",
  "jasmine-runner": "/jasmine-runner/static-1.6591",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7286",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5530",
  "quartz": "/quartz/static-1.7210",
  "react": "/react/static-7.187",
  "react-dlb": "/react-dlb/static-1.81",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16819",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5442",
  "react-virtualized": "/react-virtualized/static-2.100",
  "reference-resolvers": "/reference-resolvers/static-1.8310",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8230",
  "reporting-data": "/reporting-data/static-1.68098",
  "reporting-reports": "/reporting-reports/static-1.67776",
  "reporting-snowflake": "/reporting-snowflake/static-1.56716",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10031",
  "reporting-visualizations": "/reporting-visualizations/static-1.60174",
  "reselect": "/reselect/static-3.6",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9082",
  "sanitize": "/sanitize/static-1.4611",
  "sanitize-text": "/sanitize-text/static-1.8281",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1879",
  "signup-constants": "/signup-constants/static-1.19188",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8192",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "superstore": "/superstore/static-1.4893",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4894",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11125",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11210",
  "ui-images": "/ui-images/static-2.1190",
  "UIComponents": "/UIComponents/static-3.8551",
  "usage-tracker": "/usage-tracker/static-1.7485",
  "usage-tracker-container": "/usage-tracker-container/static-1.7475",
  "usage-tracker-core": "/usage-tracker-core/static-1.7335",
  "viral-links-lib": "/viral-links-lib/static-1.7204",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9794",
  "foundations-components": "/foundations-components/static-1.8197",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.988",
  "quartz-core": "/quartz-core/static-1.6429",
  "quick-fetch": "/quick-fetch/static-1.4018",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4791",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11283",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18176",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3500",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3487",
  "quartz-webpack": "/quartz-webpack/static-1.3434",
  "foundations-assets": "/foundations-assets/static-1.5008",
  "foundations-theming": "/foundations-theming/static-1.4568",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10293",
  "hubspotter-http": "/hubspotter-http/static-1.4752",
  "sassPrefix": "/sassPrefix/static-1.158",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7380",
  "crm-message-bus": "/crm-message-bus/static-1.43338",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22699",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13163",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13309",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9958",
  "events-data-lib": "/events-data-lib/static-1.369",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4106",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6933",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7028",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3688",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3947",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1116",
  "onboarding-tours": "/onboarding-tours/static-1.16857",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14060",
  "stylex": "/stylex/static-1.35",
  "trellis-assets": "/trellis-assets/static-1.2220",
  "trellis-components": "/trellis-components/static-1.2239",
  "trellis-theming": "/trellis-theming/static-1.1077",
  "ui-addon-teams": "/ui-addon-teams/static-1.21724",
  "quartz-auth": "/quartz-auth/static-1.885",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9203",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5171",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9286",
  "ContentUtils": "/ContentUtils/static-1.68753",
  "customer-data-properties": "/customer-data-properties/static-1-sbelsky-fix-property-definition-memoization.3",
  "forms-ai-lib": "/forms-ai-lib/static-1.4529",
  "forms-utils-lib": "/forms-utils-lib/static-1.12835",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5680",
  "react-dnd-compat": "/react-dnd-compat/static-1.4748",
  "react-tinymce": "/react-tinymce/static-1.55595",
  "tinymce-config": "/tinymce-config/static-2.54721",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10485",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3553",
  "HeadJS": "/HeadJS/static-2.774",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3265",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.182",
  "ui-fonts": "/ui-fonts/static-1.867",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4459",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.875",
  "web-vitals": "/web-vitals/static-1.7",
  "batch-promise": "/batch-promise/static-1.1678",
  "external-options-client-types": "/external-options-client-types/static-1.4228",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.885",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8060",
  "graphql": "/graphql/static-1.83",
  "persist-promise": "/persist-promise/static-1.3835",
  "reporting-client-types": "/reporting-client-types/static-1.2581",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "growth-payments-core": "/growth-payments-core/static-1.25767",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5011",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1222",
  "quartz-routing": "/quartz-routing/static-1.640",
  "hs-story-utils": "/hs-story-utils/static-1.9556",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.373",
  "timezone-utils": "/timezone-utils/static-2.5377",
  "seat-types-lib": "/seat-types-lib/static-1.311",
  "react-create-root-preference": "/react-create-root-preference/static-1.40",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4466",
  "floating-ui": "/floating-ui/static-1.58",
  "react-aria": "/react-aria/static-1.67",
  "tanstack-table": "/tanstack-table/static-1.56",
  "dispatcher": "/dispatcher/static-1.139",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.849",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.548",
  "module-federation": "/module-federation/static-1.27",
  "quartz-test": "/quartz-test/static-1.885",
  "quartz-tracking": "/quartz-tracking/static-1.589",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.201",
  "chirp-fetch": "/chirp-fetch/static-1.2022",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6118",
  "salesImages": "/salesImages/static-1.527",
  "ts-schema": "/ts-schema/static-1.4182",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "calling-global-api": "/calling-global-api/static-1.64952",
  "calling-internal-common": "/calling-internal-common/static-1.31446",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66334",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58628",
  "commerce-products-lib": "/commerce-products-lib/static-1.10059",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3899",
  "crm-links": "/crm-links/static-1.6442",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4238",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9620",
  "file-manager-components": "/file-manager-components/static-1.24000",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "hs-resources": "/hs-resources/static-1.312",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4318",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.767",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3792",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49207",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4066",
  "property-value-citations": "/property-value-citations/static-1-sbelsky-fix-property-definition-memoization.3",
  "pulse": "/pulse/static-1.738",
  "smart-property-lib": "/smart-property-lib/static-1.7944",
  "tiered-pricing": "/tiered-pricing/static-1.1565",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9202",
  "user-context": "/user-context/static-1.5242",
  "zustand": "/zustand/static-1.74",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3051",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1226",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.147",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18783",
  "growth-data-modal": "/growth-data-modal/static-1.5649",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3199",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2299",
  "navigation-components": "/navigation-components/static-1.18325",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5071",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.923",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10387",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7768",
  "ui-universal-auth": "/ui-universal-auth/static-1.9140",
  "base-ui": "/base-ui/static-1.15",
  "react-day-picker": "/react-day-picker/static-1.4",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10291",
  "magpie-lib": "/magpie-lib/static-1.5642",
  "navigation-messaging": "/navigation-messaging/static-1.7652",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21936",
  "copilot-toolkit": "/copilot-toolkit/static-1.11475",
  "cms-field-types": "/cms-field-types/static-1.4949",
  "content-icons-ui": "/content-icons-ui/static-1.2267",
  "integrations-lib": "/integrations-lib/static-1.16572",
  "final-form": "/final-form/static-1.71",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.20061",
  "tinymce-themes": "/tinymce-themes/static-1.56691",
  "data-token-picker": "/data-token-picker/static-1.16643",
  "hub-http-contrib": "/hub-http-contrib/static-1.3177",
  "interframe": "/interframe/static-3.4892",
  "tinymce-data": "/tinymce-data/static-1.40806",
  "tinymce-plugins": "/tinymce-plugins/static-1.57835",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5344",
  "onboarding-scopes": "/onboarding-scopes/static-1.6594",
  "ui-addon-opt": "/ui-addon-opt/static-4.8496",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4784",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.470",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.308",
  "purchase-motions-api": "/purchase-motions-api/static-1.6121",
  "calling-error-reporting": "/calling-error-reporting/static-1.31453",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11169",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6677",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1487",
  "customer-data-tracking": "/customer-data-tracking/static-1.7020",
  "commerce-permissions": "/commerce-permissions/static-1.909",
  "products-iframe-lib": "/products-iframe-lib/static-1.8298",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10675",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9638",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1177",
  "immerable": "/immerable/static-1.4284",
  "video-components-external": "/video-components-external/static-1.11722",
  "video-data-lib": "/video-data-lib/static-1.35380",
  "event-emitter": "/event-emitter/static-1.1084",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.241",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "data-agent-kit": "/data-agent-kit/static-1.417",
  "feedback-loader": "/feedback-loader/static-1.29544",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10376",
  "fsm": "/fsm/static-1.3865",
  "policy-lib": "/policy-lib/static-1.6920",
  "react-colorpicker": "/react-colorpicker/static-2.10341",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10439",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17901",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2200",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2327",
  "user-context-client": "/user-context-client/static-1.4713",
  "idb-keyval": "/idb-keyval/static-1.45",
  "magpie-types": "/magpie-types/static-1.5102",
  "nest": "/nest/static-1.366",
  "reactive-lib": "/reactive-lib/static-1.860",
  "simple-logging-lib": "/simple-logging-lib/static-1.3183",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.936",
  "markdown-it": "/markdown-it/static-1.6",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13987",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5741",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7915",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10496",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.654",
  "FileManagerLib": "/FileManagerLib/static-1.39640",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9155",
  "FileManagerCore": "/FileManagerCore/static-1.39499",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7966",
  "layout-dnd-components": "/layout-dnd-components/static-1.12707",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11682",
  "react-codemirror": "/react-codemirror/static-1.10761",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10019",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15760",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36264",
  "sales-views-client-types": "/sales-views-client-types/static-1.4390",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3686",
  "breeze-engine-core": "/breeze-engine-core/static-1.455",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12731",
  "content-media-compositions": "/content-media-compositions/static-2.16738",
  "media-bridge-lib": "/media-bridge-lib/static-1.19159",
  "trellis-story-utils": "/trellis-story-utils/static-1.4643",
  "storybook-react": "/storybook-react/static-1.34",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15170",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7739",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3145",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.64",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.487",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.626",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.784",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.82",
  "slack-ui-library": "/slack-ui-library/static-1.10530",
  "audio-components": "/audio-components/static-1.6122",
  "FileManagerImages": "/FileManagerImages/static-1.37151",
  "video-components": "/video-components/static-1.13724",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4668",
  "video-embed": "/video-embed/static-1.36214",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8839",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28929",
  "ContentData": "/ContentData/static-1.68828",
  "layout-data-lib": "/layout-data-lib/static-1.10007",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22397",
  "outpost": "/outpost/static-1.4302",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6713",
  "advanced-menus-core": "/advanced-menus-core/static-1.15350",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12258",
  "ExportDialog": "/ExportDialog/static-6.10513",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34403",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15349",
  "simple-menus-lib": "/simple-menus-lib/static-1.16866"
}
};
